var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "scrollContainer",
    staticClass: "profile-container",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('h4', {
    ref: "mainHeader",
    staticClass: "main-header"
  }, [_vm._v(_vm._s(_vm.$t('profile.my')))]), _c('div', {
    staticClass: "profile-column"
  }, [_c('div', {
    ref: "navigation",
    staticClass: "profile",
    class: {
      'sticky': _vm.isSticky
    }
  }, [_c('router-view', {
    attrs: {
      "name": "sidebar"
    }
  })], 1), _c('div', {
    ref: "profileContent",
    staticClass: "profile-content"
  }, [_c('router-multi-view', {
    attrs: {
      "view-name": "tab"
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }